'use client';
import { faTimer, IconDefinition, faStars } from '@fortawesome/pro-solid-svg-icons';
import { useMemo } from 'react';

import { Icon } from '@/components/ui/icon.component';
import { SearchPartnerData } from '@/app/(main)/(pages)/busca/[slug]/_types/search-partner-data.type';

interface SearchTagProps {
  professional: SearchPartnerData['professional'];
  isPromotionUrgent?: boolean;
  isHiddenByPromotionalPill?: boolean;
}

export const SearchTag = ({
  professional,
  isPromotionUrgent = false,
  isHiddenByPromotionalPill = false,
}: SearchTagProps) => {
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

  const isProfessionalNew = professional?.createdAt ? new Date(professional.createdAt) > oneMonthAgo : false;

  const badgeDetails = useMemo((): { label: string; icon: IconDefinition } | null => {
    if (isHiddenByPromotionalPill) {
      return null;
    }

    if (isPromotionUrgent) {
      return { label: 'Poucos horários restantes', icon: faTimer };
    }

    if (isProfessionalNew) {
      return { label: 'Acabou de chegar', icon: faStars };
    }

    return null;
  }, [isPromotionUrgent, isHiddenByPromotionalPill, isProfessionalNew]);

  if (!badgeDetails) {
    return null;
  }

  return (
    <div
      className="bg-pink-100 border-pink-100 text-pink-700 font-semibold px-2 py-1 rounded-md border w-fit flex items-center gap-1 mb-4"
      data-testid="search-tag--search-card"
    >
      <Icon data-testid="search-tag-icon--search-card" icon={badgeDetails.icon} size="sm" className="font-semibold" />
      <div data-testid="search-tag-label--search-card">
        <span>{badgeDetails.label}</span>
      </div>
    </div>
  );
};
